import "./banner.css";
import photo1 from "../../assets/images/DJI_0563.jpg";
import photo2 from "../../assets/images/DJI_0564.jpg";
import photo3 from "../../assets/images/DJI_0566.jpg";
import photo4 from "../../assets/images/DJI_0569.jpg";
import photo5 from "../../assets/images/DJI_0571.jpg";
// Добавь свои фото в assets/images/

import { useState, useEffect } from "react";
import { useTranslation } from "../../shared/LanguageContext";

const images = [photo1, photo2, photo3, photo3, photo4, photo5];

const Banner = () => {
    const [active, setActive] = useState(0);
    const { t } = useTranslation();

    useEffect(() => {
        const timer = setInterval(() => {
            setActive((prev) => (prev + 1) % images.length);
        }, 4200);
        return () => clearInterval(timer);
    }, []);

    return (
        <div className="banner-carousel-container">
            <div className="banner-carousel-slider">
                {images.map((img, idx) => (
                    <img
                        key={idx}
                        src={img}
                        alt=""
                        className={`carousel-img${idx === active ? " active" : ""}`}
                        draggable="false"
                    />
                ))}
                <div className="banner-carousel-overlay" />
                <div className="banner-content">
                    <div className="banner-heading">
                        <h1>{t("banner_title_1")} <br /><span>OQ SAROY hospital</span></h1>
                        <h4>{t("banner_title_2")}<br />{t("banner_title_3")}</h4>
                    </div>
                    <div className="banner-subheading">
                        <p>{t("banner_desc")}</p>
                    </div>
                    <div className="banner-buttons">
                        <a
                            href="https://t.me/OQSAROY_HOSPITAL"
                            className="banner-appointment-button"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {t("banner_btn")}
                        </a>
                    </div>
                </div>
                <div className="banner-carousel-dots">
                    {images.map((_, idx) => (
                        <button
                            key={idx}
                            className={active === idx ? "active" : ""}
                            onClick={() => setActive(idx)}
                            aria-label={`Показать фото ${idx + 1}`}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Banner;
